// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialogForm .el-input[data-v-d3c5d7f0] {\n  width: 240px;\n}\n.flex[data-v-d3c5d7f0] {\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n}\n.flex .group-tree[data-v-d3c5d7f0] {\n  width: 250px;\n  overflow: auto;\n}\n.show-tree[data-v-d3c5d7f0] {\n  font-size: 14px;\n}\n[data-v-d3c5d7f0] .el-tree .el-tree-node__content {\n  width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n}", ""]);
// Exports
module.exports = exports;
